export const RATINGS_IS_LOADING = 'RATINGS_IS_LOADING';
export const RATING_SAVING = 'RATING_SAVING';
export const RATING_SAVED = 'RATING_SAVED';
export const RATINGS_FETCHED = 'RATINGS_FETCHED';
export const CONF_RATINGS_FETCHED = 'CONF_RATINGS_FETCHED';
export const LEADERBOARD_FETCHED = 'LEADERBOARD_FETCHED';
